import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=26cfc6f4&"
import script from "./SignUpModal.vue?vue&type=script&lang=ts&"
export * from "./SignUpModal.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&id=26cfc6f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports